import api from '@/services/api'

export const getNBoxes = async () => {
    try {
        const resp = await api.get('n-boxes')
        return resp.data.data
    } catch (e) {
        console.log(e)
    }
}

export const updateNBox = async (nBoxID, data) => {
    try {
        return api.put(`n-boxes/${nBoxID}`, data)
    } catch (e) {
        console.log(e)
    }
}

export const deleteNBox = async (nBoxID) => {
    try {
        return api.delete(`n-boxes/${nBoxID}`)
    } catch (e) {
        console.log(e)
    }
}

export const downloadNBox = async (nBoxId) => {
    try {
        return await api.get(`n-boxes/${nBoxId}/download`, {
            responseType: 'arraybuffer',
        })
    } catch (e) {
        console.log(e)
    }
}
